@switch (menuId()) {
  @case ('profile') {
    <div class="header-popin-profil">
      <div class="header-popin-profil_user">
        <mat-icon>person</mat-icon>
        <h2 class="heading-xs">
          {{ accountService.user().profileBc?.firstName }} {{ accountService.user().profileBc?.lastName }}
        </h2>
      </div>
      <div class="header-popin-profil__container">
        <a
          class="header-popin-profil__navigation"
          [routerLink]="['/protected/proposal/requests']">
          <div class="content">
            <mat-icon>colorize</mat-icon>
            <p class="body-m">{{ 'popin-header.requests' | translate }}</p>
          </div>
        </a>
        <a
          class="header-popin-profil__navigation"
          [routerLink]="['/protected/orders/v2']">
          <div class="content">
            <mat-icon>shopping_cart</mat-icon>
            <p class="body-m">{{ 'popin-header.orders' | translate }}</p>
          </div>
        </a>
        <a
          class="header-popin-profil__navigation"
          [routerLink]="['/protected/profile']">
          <div class="content">
            <mat-icon>edit</mat-icon>
            <p class="body-m">{{ 'popin-header.edit-profil' | translate }}</p>
          </div>
        </a>
        @if (accountService.user().isAdmin) {
          <a class="header-popin-profil__navigation" [routerLink]="['/admin']">
            <div class="content">
              <mat-icon>admin_panel_settings</mat-icon>
              <p class="body-m">Admin</p>
            </div>
          </a>
        }
        <a class="header-popin-profil__navigation" (click)="logout()">
          <div class="content">
            <mat-icon>exit_to_app</mat-icon>
            <p class="body-m">
              {{ 'popin-header.log-out' | translate }}
            </p>
          </div>
        </a>
      </div>
    </div>
  }
  @case ('cartV2') {
    <div class="header-popin-menu">
      <div class="header-cart">
        <app-button type="secondary" icon="shopping_cart"></app-button>
        @if (cartV2Service.cart()?.lineItems?.length ?? 0 > 0) {
          <p
            class="body-m-bold">
            {{ cartV2Service.cart()?.lineItems?.length }}
            {{ 'popin-header.products' | translate }}
          </p>
        } @else {
          <p class="body-m-bold">
            {{ 'popin-header.basket-empty' | translate }}
          </p>
        }
      </div>
      @if (accountService.user().isAuthenticated) {
        @if (cartV2Service.cart()?.lineItems?.length ?? 0 > 0) {
          <app-cart-table-v2
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns"
            [total]="cartV2Service.cart()?.cartAmount"></app-cart-table-v2>
        } @else {
          <app-cart-empty></app-cart-empty>
        }
      }
    </div>
  }
}
